import React from 'react';

import PinAndPhone from '../components/PinAndPhone';

const PinAndPhonePage = () => {
  return <PinAndPhone />;
};

export default PinAndPhonePage;
